import { Component, Input } from '@angular/core';
import { PalantirContentComponent } from '../content/content.component';
import { PalantirLayoutComponent } from '../layout/layout.component';

@Component({
  selector: 'palantir-card',
  standalone: true,
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  imports: [PalantirContentComponent, PalantirLayoutComponent],
})
export class PalantirCardComponent {
  @Input() public activatable?: boolean;
}
